import React, { useContext } from "react";
import { MdOutlineLightMode, MdDarkMode } from "react-icons/md";
import { GiCubes } from "react-icons/gi";
import { ModeContext } from "../utils/modes-context";

import "./navbar.css";

const Navbar = () => {
  const { darkMode, modeSwitchHandler } = useContext(ModeContext);

  return (
    <nav className="navbar">
      <h1 className="logo">K</h1>
      <button className="modes" onClick={modeSwitchHandler}>
        {darkMode ? (
          <MdOutlineLightMode className="lightmode" />
        ) : (
          <MdDarkMode className="darkmode" />
        )}
      </button>
    </nav>
  );
};

export default Navbar;
